import { Button } from "./button";

export interface FaqCardProps {
  title: string;
  subtitle: string;
  buttonLabel: string;
  onClick: () => void;
}

export default function FaqCard({
  title,
  subtitle,
  buttonLabel,
  onClick,
}: FaqCardProps) {
  return (
    <div className="flex flex-col gap-3 py-2 w-fit">
      <div>
        <h3 className="text-base font-semibold text-n-text-green">{title}</h3>
        <p className="text-sm  text-n-text">{subtitle}</p>
      </div>
      <Button
        className="px-3 py-2 text-sm w-fit font-bold"
        size="sm"
        onClick={onClick}
      >
        {buttonLabel}
      </Button>
    </div>
  );
}
